package com.parmartechnologies.core.feature.customer.network

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class FindCustomerRequest(
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("business_id") val BusinessID: String,
)

@Serializable
data class FetchCustomerRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String
)

@Serializable
data class CreateCustomerRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("name") val name: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("email_id") val email: String,
    @SerialName("bar_code") val Barcode: String,
    @SerialName("device_id") val deviceID: String,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
)

@Serializable
data class UpdateCustomerRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("_id") val _id: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("name") val name: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("email_id") val email: String,
    @SerialName("bar_code") val Barcode: String,
    @SerialName("device_id") val deviceID: String,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
)